import { render, staticRenderFns } from "./ClientProfile.vue?vue&type=template&id=38413efb&scoped=true"
import script from "./ClientProfile.vue?vue&type=script&lang=js"
export * from "./ClientProfile.vue?vue&type=script&lang=js"
import style0 from "./ClientProfile.vue?vue&type=style&index=0&id=38413efb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38413efb",
  null
  
)

export default component.exports